import { render, staticRenderFns } from "./DashboardWidgetContoEconomico.vue?vue&type=template&id=fb682ac0&"
import script from "./DashboardWidgetContoEconomico.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetContoEconomico.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetContoEconomico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports